import { render } from "./EducationView.vue?vue&type=template&id=f4ca55d2&scoped=true&ts=true"
import script from "./EducationView.vue?vue&type=script&lang=ts"
export * from "./EducationView.vue?vue&type=script&lang=ts"

import "./EducationView.vue?vue&type=style&index=0&id=f4ca55d2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4ca55d2"]])

export default __exports__